import { z } from "zod";
import { LookupListPage } from "./LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { printerId: number; printerName: string; description: string | null; standardA4Printer: boolean; labelPrinter: boolean; deleted: boolean; }
const schema = z.object({
  printerName: z.string().min(1).max(100),
  description: z.string().max(200).nullable().optional(),
  standardA4Printer: z.boolean(),
  labelPrinter: z.boolean(),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function PrintersPage() {
  return <LookupListPage<Row, Form>
    title="Printers"
    apiPath="/api/lookups/printers"
    schema={schema}
    rowKey={(r) => r.printerId}
    columns={[
      { id: "name", header: "Name", accessor: (r) => r.printerName },
      { id: "desc", header: "Description", accessor: (r) => r.description ?? "—" },
      { id: "a4",   header: "A4",   accessor: (r) => r.standardA4Printer ? "Yes" : "—" },
      { id: "lab",  header: "Label", accessor: (r) => r.labelPrinter ? "Yes" : "—" },
    ]}
    toFormValues={(r) => ({ printerName: r.printerName, description: r.description ?? "", standardA4Printer: r.standardA4Printer, labelPrinter: r.labelPrinter, deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ printerName: "", description: "", standardA4Printer: false, labelPrinter: false, deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="n">Name</Label><Input id="n" {...f.register("printerName")} /></div>
        <div><Label htmlFor="d">Description</Label><Input id="d" {...f.register("description")} /></div>
        <label className="flex items-center gap-2"><input type="checkbox" {...f.register("standardA4Printer")} /> Standard A4 printer</label>
        <label className="flex items-center gap-2"><input type="checkbox" {...f.register("labelPrinter")} /> Label printer</label>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
